import { constructAsync } from '../../../webmodule-common/other/async-constructor';
import { customElement, state } from 'lit/decorators.js';
import { disposeOf } from '../../../webmodule-common/other/dispose';

import { html } from 'lit';
import { PageBase } from './helpers/page-base';
import { tlang } from '../../../webmodule-common/other/language/lang';

import { TenantView } from '../../dealers/view/tentant-view';

@customElement('app-dealers')
export class AppDealers extends PageBase {
  @state()
  private tenantView: TenantView | null = null;

  constructor() {
    super();
  }

  async dispose() {
    await super.dispose();
    await disposeOf(this.tenantView);
    this.tenantView = null;
  }

  render() {
    if (!this.loggedIn) return html``;
    return html` <div class="page-content">
      <div class="page-container">${this.tenantView?.ui}</div>
    </div>`;
  }

  meta() {
    return {
      title: tlang`SoftTech Dealer License Server - Tenants`,
      description: tlang`Supplier Tenant Settings Page`
    };
  }

  protected async canLeavePage(): Promise<boolean> {
    if (this.tenantView) return await this.tenantView.canClose();
    else return true;
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  protected async afterUserConnected() {
    //we need to flush the user data store any time we come to this page in case it is stale information
    this.tenantView = await constructAsync(new TenantView());
  }
}
